@if (loading) {
  <loading class="pos-fix vh-center"
    >
  </loading>
}
<app-checkup-view-experiment [isFromListView]="isFromListView" [instantCheckup]="instantCheckup"></app-checkup-view-experiment>